<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title>
          USUARIOS
        </ion-title>
        <ion-select class="select-emp pr-2" slot="end" placeholder="EMPRESA" v-model="empresaActual" cancel-text="CANCELAR" @ionChange="listarUsuariosEmpresa();">
          <ion-select-option v-for="empresa in empresas" :key="empresa.emp_id+'emp'" :value="empresa.emp_id">{{empresa.emp_nombre}}</ion-select-option>
        </ion-select>
      </ion-toolbar>
      <ion-toolbar>
        <ion-searchbar placeholder="BUSCAR" v-model="filtroBusqueda" animated="true" debounce="50" @ionChange="filtrarUsuarios()"></ion-searchbar>
      </ion-toolbar>
    </ion-header>
    
    <ion-content>
      <ion-refresher slot="fixed" @ionRefresh="recargarUsuarios($event);" >
        <ion-refresher-content></ion-refresher-content>
      </ion-refresher>
      <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button @click="muestraModalNuevoUsuario();" color="secondary">
          <ion-icon name="add"></ion-icon>
        </ion-fab-button>
      </ion-fab>

      <ion-grid v-if="usuarios.length == 0" class="ion-text-center ion-margin-top ion-padding-top">
        <ion-row class="ion-justify-content-center ion-margin-top ion-padding-top">
          <ion-col size="12">
            <ion-label color="dark">SIN USUARIOS PARA LISTAR.</ion-label>
          </ion-col>
        </ion-row>
      </ion-grid>

      <ion-list v-else class="mb-5 pb-5" lines="full">
        <ion-item v-for="usuario in usuarios" :key="usuario.usr_rut" button @click="muestraModalVerUsuario(usuario)">
          <ion-label>
            <h3 v-text="usuario.usr_nombres+' '+usuario.usr_apellido_p+' '+usuario.usr_apellido_m"></h3>
            <div class="row justify-content-between">
              <div class="col">
                <p class="text-muted">{{formateaRut(usuario.usr_rut+usuario.usr_dv)}}</p>
              </div>
              <div class="col text-right text-muted">
                <!-- <h3 v-if="usuario.usr_tipo_usuario == 1" class="text-white text-center ml-auto my-0 py-1 font-weight-bold bg-secondary rounded-circle" style="width:24px; height:24px;">A</h3>
                <h3 v-if="usuario.usr_tipo_usuario == 2" class="text-white text-center ml-auto my-0 py-1 font-weight-bold bg-secondary rounded-circle" style="width:24px; height:24px;">I</h3>
                <h3 v-if="usuario.usr_tipo_usuario == 3" class="text-white text-center ml-auto my-0 py-1 font-weight-bold bg-secondary rounded-circle" style="width:24px; height:24px;">S</h3>
                <h3 v-if="usuario.usr_tipo_usuario == 4" class="text-white text-center ml-auto my-0 py-1 font-weight-bold bg-secondary rounded-circle" style="width:24px; height:24px;">N</h3>
                <h3 v-if="usuario.usr_tipo_usuario == 6" class="text-white text-center ml-auto my-0 py-1 font-weight-bold bg-secondary rounded-circle" style="width:24px; height:24px;">X</h3> -->
                <p class="text-muted">{{usuario.usr_nombre_tipo}}</p>
              </div>
            </div>
          </ion-label>
        </ion-item>
      </ion-list>

    </ion-content>
    
  </ion-page>
</template>

<script>
import { Preferences  } from '@capacitor/preferences';
import { addIcons     } from 'ionicons';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonMenuButton, IonButtons, IonIcon, IonLabel, IonRefresher, IonRefresherContent, 
        IonFab, IonFabButton, IonGrid, IonRow, IonCol, IonList, IonItem, modalController, toastController, IonSearchbar, loadingController, 
        IonSelect, IonSelectOption } from '@ionic/vue';
import { add } from 'ionicons/icons';
import { defineComponent }  from 'vue';

import { cerrarSesion }     from '@/plugins/funciones.ts';
import axios                from 'axios';
import rutaBase             from '@/plugins/variables';
import mVerUsuario          from '../../components/ModalVerUsuario.vue';
import mNuevoUsuario        from '../../components/ModalNuevoUsuario.vue';

export default defineComponent({
  name: 'Usuarios',
  components: {
    IonHeader, IonToolbar, IonTitle, IonContent, IonPage, IonMenuButton, IonButtons, IonIcon, IonLabel, IonRefresher, IonRefresherContent, IonFab, 
    IonFabButton, IonGrid, IonRow, IonCol, IonList, IonItem, IonSearchbar, IonSelect, IonSelectOption
  },
  data() {
    return { 
      cargando            : false,
      usuarios            : [],
      usuariosTodos       : [],
      filtroBusqueda      : '',
      modalNuevoUsuario   : null,
      modalVerUsuario     : null,
      modalCargando       : null,
      empresas            : [],
      empresaActual       : ''
    }
  },
  created() {
    addIcons({
      'add' : add
    });
  },
  mounted(){
    this.listarEmpresas();
  },
  methods:{
    async muestraModalCargando(){
      const modalCargando = await loadingController
        .create({
          cssClass  : 'text-secondary',
          message   : 'CARGANDO...',
          animated  : false,
          mode      : 'md'
        });
      await modalCargando.present();
      return modalCargando;
    },

    filtroUsuarios(filtro){
      const filtros = filtro.split(' ');
      return this.usuariosTodos.filter((item) => {
        for(let i=0; i < filtros.length; i++) {
          if(item.usr_correo){
            return  item.usr_rut.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(filtros[i].toLowerCase()) > -1 || 
                  item.usr_nombres.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(filtros[i].toLowerCase()) > -1 || 
                  item.usr_apellido_p.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(filtros[i].toLowerCase()) > -1 ||
                  item.usr_apellido_m.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(filtros[i].toLowerCase()) > -1 ||
                  item.usr_correo.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(filtros[i].toLowerCase()) > -1;
          }
          else {
            return  item.usr_rut.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(filtros[i].toLowerCase()) > -1 || 
                  item.usr_nombres.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(filtros[i].toLowerCase()) > -1 || 
                  item.usr_apellido_p.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(filtros[i].toLowerCase()) > -1 ||
                  item.usr_apellido_m.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(filtros[i].toLowerCase()) > -1;
          }
        }
      });
    },

    filtrarUsuarios(){
      if(this.filtroBusqueda == ''){
        this.usuarios = this.usuariosTodos;
      }
      else {
        this.usuarios = this.filtroUsuarios(this.filtroBusqueda);
      }
    },

    async recargarUsuarios(evento=false){
      const token   = await Preferences.get({ key: 'token_auth' });
      const headers = { headers: { 'Authorization': `${token.value}` } };
      const dato    = new URLSearchParams();
      dato.append('id_empresa', this.empresaActual);
      axios.post(rutaBase+'/administrador/listarUsuariosEmpresa', dato, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.usuariosTodos = resp.data.usuarios;
        this.filtrarUsuarios();
        if(evento){ evento.target.complete(); }
      }).catch(() =>{
        if(evento){ evento.target.complete(); }
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async listarEmpresas(){
      const modalCargando   = await this.muestraModalCargando();
      const token           = await Preferences.get({ key: 'token_auth' });
      const headers         = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/administrador/listarEmpresasPorRut', null, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.empresas = resp.data.empresas;
        this.empresaActual = this.empresas[0].emp_id;
        modalCargando.dismiss();
        this.listarUsuariosEmpresa();
      }).catch(()=>{
        modalCargando.dismiss();
        this.muestraToast('ERROR AL OBTENER EMPRESAS.');
      });
    }, 

    async listarUsuariosEmpresa(){
      const modalCargando   = await this.muestraModalCargando();
      const token   = await Preferences.get({ key: 'token_auth' });
      const headers = { headers: { 'Authorization': `${token.value}` } };
      const dato    = new URLSearchParams();
      dato.append('id_empresa', this.empresaActual);
      axios.post(rutaBase+'/administrador/listarUsuariosEmpresa', dato, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.usuariosTodos   = resp.data.usuarios;
        this.filtrarUsuarios();
        modalCargando.dismiss();
      }).catch(() =>{
        modalCargando.dismiss();
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async muestraModalVerUsuario(usuario){
      this.modalVerUsuario = await modalController
        .create({
          component: mVerUsuario,
          componentProps: { 
            usuarioProp: usuario
          },
          backdropDismiss: false
        });
      this.modalVerUsuario.present();
      const modalResponse = await this.modalVerUsuario.onDidDismiss();
      modalResponse.data && this.modalCloseHandler({...modalResponse.data})
    },

    async muestraModalNuevoUsuario(){
      this.modalNuevoUsuario = await modalController
        .create({
          component: mNuevoUsuario,
          componentProps: {},
          backdropDismiss: false
        });
      this.modalNuevoUsuario.present();
      const modalResponse = await this.modalNuevoUsuario.onDidDismiss();
      modalResponse.data && this.modalCloseHandler({...modalResponse.data})
    },

    modalCloseHandler(_value) {
      const datos = _value;
      if(datos.recargar){
        this.listarUsuariosEmpresa();
      }
    },

    formateaRut(rut){
      const newRut = rut.replace(/\./g,'').replace(/[^k|K|\d]/g, '').replace(/-/g, '').trim().toUpperCase();
      const lastDigit = newRut.substr(-1, 1);
      const rutDigit = newRut.substr(0, newRut.length-1)
      let format = '';
      let i = 0;
      let j = 1;
      for (i = rutDigit.length - 1; i >= 0; i--) {
        const e = rutDigit.charAt(i);
        format = e.concat(format);
        if (j % 3 == 0 && j <= rutDigit.length - 1) {
          format = '.'.concat(format);
        }
        j++;
      }
      let formateado = "";
      if(format.length > 0){
        formateado = format.concat('-').concat(lastDigit);
      }
      else{
        formateado = lastDigit;
      }
      return formateado;
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 2000,
          cssClass: 'text-center'
        })
      return toast.present();
    }
  }
});
</script>
<style>
.searchbar-input-container input {
  border-radius: 50rem!important;
  background-color: lightgrey!important;
  color: black!important;
}
</style>